const IBAN = require('iban')

export default (value) => {
  const parsedValue = String(value)
  return IBAN.isValid(parsedValue)
}
